module.exports = __webpack_public_path__ + "media/images/emblems/Wappen_Endingen_2014-62b7517308d44e6f50ac80f7d47992e5.png";